// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bkC7","icon":"styles_icon__11l3B"};